export const getMonday = (number = 0, now) => {
	let prevMonday = new Date(now);
	console.log(prevMonday)
	prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7 - number * 7);
	prevMonday.setHours(0, 0, 0, 0);
	return prevMonday;
};
